import { GeosetsCreatePage, GeofencesRoute } from './-components';
import { createFileRoute, useRouter } from '@tanstack/react-router';

function GeosetsCreateRoute() {
  const router = useRouter();

  return (
    <GeofencesRoute
      permission="journeys/geofences/create"
      redirectTo={(params) =>
        router.buildLocation({
          to: '/workspaces/$workspaceId/geosets',
          params: { workspaceId: params.workspaceId },
        }).href
      }
    >
      <GeosetsCreatePage />
    </GeofencesRoute>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/geosets/new')({
  component: GeosetsCreateRoute,
});
